(function () {
    'use strict';

    angular
        .module('app.shared')
        .component('sc3HandicapCalculation', {
            templateUrl: 'app/shared/handicap-calculation/handicap-calculation.component.html',
            controller: HandicapCalculationComponent,
            bindings: {
                calculation: '<'
            }
        });

    var $ = angular.element;

    HandicapCalculationComponent.$inject = ['$filter', '$window', '$element', '$locale', 'emailModal', 'defaultHandicapCalculationEmailTitle', 'defaultHandicapCalculationEmailSubject', 'cultureName'];
    function HandicapCalculationComponent($filter, $window, $element, $locale, emailModal, defaultHandicapCalculationEmailTitle, defaultHandicapCalculationEmailSubject, cultureName) {
        var ctrl = this,
            numberFilter = $filter('number'),
            mainElement;

        Object.defineProperty(ctrl, 'isFrench', { get: getIsFrench });

        ctrl.$onInit = init;
        ctrl.formatNumber = formatNumber;
        ctrl.print = print;
        ctrl.email = email;
        ctrl.getChartCellStyle = getChartCellStyle;

        /////////////////////////////////////////////

        function init() {
            var calc = ctrl.calculation;
            //ctrl.reductionType = !calc.numCalcScores ? 'NoHandicap' : calc.numTScores < 2 ? 'Ineligible' : 'Eligible';
            ctrl.adjustmentType = calc.lowValueDifference > 3.0 ? calc.softCap >= 5.0 ? 'HardCap' : 'SoftCap' : 'None';
            //ctrl.isElgableForReduction = ctrl.reductionType === 'Eligible';
            ctrl.isEligableForSoftCap = ctrl.adjustmentType === 'SoftCap';
            ctrl.isEligableForHardCap = ctrl.adjustmentType === 'HardCap';
            ctrl.isLowScoreCountAdjustment = calc.lowScoreCountAdjustment > 0;
            
            //ctrl.isReduced = ctrl.isElgableForReduction && ctrl.calculation.tDiffLookup >= 3;

            mainElement = $($element[0].querySelector('.calc-calculation'));
        }

        function formatNumber(number) {
            number = Math.abs(number)
            return number != 99.9 ? numberFilter(number, 1) : null;
        }

        function print() {
            var body = $(document.body),
                clone = mainElement.clone().addClass('print-only');

            $(document.body).append(clone);
            // $(document.body).addClass('print-test');
            $window.print();
            clone.remove();
        }

        function email() {
            var clone = mainElement.clone(),
                wrapper;

            // Emails cannot handle css transformations.  
            // Remove YAxis label for T- Reduction Chart.
            $(clone[0].querySelector('.calc-yaxis-label')).remove();

            // Replace div with table, so email will honor width.
            wrapper = $('<table><tr><td></td></tr></table>').attr('style', clone.attr('style'))
            wrapper.find('td').append(clone.children());        

            emailModal({
                title: defaultHandicapCalculationEmailTitle,
                address: ctrl.calculation.email,
                subject: defaultHandicapCalculationEmailSubject,
                body: wrapper[0].outerHTML
            });
        }

        function getChartCellStyle(value) {
            return (value < 0 ? 'font-weight: bold; background-color: #D3D3D3 !important;' : '') + 'padding: 3px; border: solid 1px #ddd; text-align: right;';
        }

        function getIsFrench() {
            return $locale.id === cultureName.fr.toLowerCase() || $locale.id === cultureName.fr_CA.toLowerCase();
        }
    }
})();